var ko = require('knockout');
var viewModelBase = require('../view_model/base.js');

// Global view model class that presents modal dialogs and manages their state.
// A singleton instance of Manager is stored as tk.viewModels['_dialogManager']
var DialogManager = viewModelBase.create({
  init: function(){
    this._afterRender = $.proxy(this._afterRender, this);
    this._contentViewModel = ko.observable({});
    this._isVisible = ko.observable(false);
    this._isCentered = ko.observable(false);
  },

  // Private: Runs after the dialog content has been rendered.
  //
  // If _isCentered is set to true, adjusts the dialog content margin so that it
  // will be centered vertically and horizontally.
  //
  // elements - A collection of elements that will be rendered inside the dialog
  // content template.
  //
  // Returns nothing.
  _afterRender: function(elements) {
    if (this._isCentered()) {
      // Use a timeout so CSS transitions have a chance to activate.
      setTimeout(function() {
        var dialogContent = $(elements[0].parentNode);
        dialogContent.css({
          'margin-left': ((dialogContent.width() / 2) * -1) + 'px',
          'margin-top': ((dialogContent.height() / 2) * -1) + 'px'
        });
      }, 1);
    }
  },

  // Public: Sets the dialog's content view model and makes it visible on the
  // page. The `content` model can be any JavaScript object with a `templateName`
  // property, which should be the ID of a template that exists on the current page
  // that will be rendered as the dialog's contents using the provided model.
  // If your model's templateName is 'my-awesome-template', Knockout will render the
  // contents of that template using the model as its binding context.
  //
  // content - A view model object with any data or behavior needed for this dialog;
  //           as noted above, it must have a `templateName` property.
  //
  // Returns nothing.
  presentDialog: function(content){
    this._contentViewModel(content);
    this._isCentered(content.isCentered);
    this._isVisible(true);

    // Use a timeout so CSS transitions have a chance to activate.
    setTimeout( function() {
      $('html').addClass('tk-dialog-open');
    }, 1);
  },

  // Public: Dismisses the currently displayed dialog. Returns nothing.
  dismiss: function(){
    this._isVisible(false);
    this._contentViewModel({});
    $('html').removeClass('tk-dialog-open');
  },

  // Internal: Identifies the template to be used for the dialog, using the
  // content view model's templateName property.
  //
  // _contentViewModel - The dialog's contentViewModel; it's passed in as an
  //                     an argument because that's how Knockout does it.
  //
  // Returns the template name as a string or undefined.
  templateName: function(_contentViewModel){
    return _contentViewModel.templateName;
  }
});


module.exports = {
  // Public: Returns the global instance of the dialog manager.
  //
  // Returns DialogManager;
  getInstance: function() {
    if (!global._dialogManagerInstance) {
      global._dialogManagerInstance = new DialogManager();
    }

    return global._dialogManagerInstance;
  },

  // This should only be used for tests.
  _Class: DialogManager
};
